﻿export function requestLocationFromBrowser() {
    return new Promise((resolve, reject) => {
        if (!!navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => resolve(position), error => reject(error));
        } else {
            reject(new Error('Your browser does not support location'));
        }
    });
}